import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import dayjs from 'dayjs';
import MyRangePicker from "../../../../ui-component/MyRangePicker";

interface DataItem {
    date: any;

    [key: string]: any;
}

interface GeneralDatePickerComponentProps {
    mainContent?: Array<any>;
    setDisplayedData?: any;
    singleDateMode?: boolean;
    column?: boolean;
    date?: Date;
    setDate?: (date: Date) => void;
    styleObject?: any;
}

const GeneralDatePickerComponent: React.FC<GeneralDatePickerComponentProps> = ({
    mainContent,
    setDisplayedData,
    singleDateMode = true,
    column = false,
    date,
    setDate,
    styleObject
}) => {
    const [fromDate, setFromDate] = useState<Date | null>(date ?? null);
    const [toDate, setToDate] = useState<Date | null>(date ?? null);
    const [open, setOpen] = useState(false);

    const handleFilterData = () => {
        if (!fromDate) return;

        let filteredData: any[] = [];
        if (singleDateMode) {
            filteredData = mainContent.filter(
                (item) => dayjs(item.date).isAfter(dayjs(fromDate)) || dayjs(item.date).isSame(dayjs(fromDate), 'day')
            );
        } else if (fromDate && toDate) {
            filteredData = mainContent.filter(
                (item) => dayjs(item.date).isAfter(dayjs(fromDate)) && dayjs(item.date).isBefore(dayjs(toDate))
            );
        }

        setDisplayedData ? setDisplayedData(filteredData) : null;
    };


    const getCurrentDate = () => {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    return (
        singleDateMode ?   <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: column ? 'column' : 'row',
                    gap: '10px',
                    maxHeight: 'fit-content',
                    ...styleObject
                }}
            >
                <DatePicker
                    label="מתאריך"
                    inputFormat="dd-MM-yyyy"
                    value={fromDate}
                    onChange={(date) => {
                        if (setDate) setDate(date);
                        setFromDate(date);
                        // handleFilterData();
                    }}
                    renderInput={(props) => <TextField {...props} sx={{ maxWidth: 'auto', margin: '0px' }} variant="standard" />}
                />
                {!singleDateMode && (
                    <DatePicker
                        label="לתאריך"
                        inputFormat="dd-MM-yyyy"
                        value={toDate}
                        onChange={(date) => {
                            if (setDate) setDate(date);
                            setToDate(date);
                            // handleFilterData();
                        }}
                        renderInput={(props) => <TextField {...props} sx={{ maxWidth: 'auto' }} variant="standard" />}
                    />
                )}
            </Box>
        </LocalizationProvider> : <MyRangePicker range={date} setRange={setDate}  />

    );
};

export default GeneralDatePickerComponent;
